<script setup>
import { computed } from 'vue';
import { initials } from '@/constants/risk';

// Avatar initials, name and LRN for a student row.
const props = defineProps({
  name: { type: String, default: '' },
  lrn: { type: [String, Number], default: '' },
});
const letters = computed(() => initials(props.name));
</script>

<template>
  <div class="student">
    <span class="student__avatar" aria-hidden="true">{{ letters }}</span>
    <span class="student__text">
      <span class="student__name">{{ name }}</span>
      <span v-if="lrn" class="student__lrn">LRN {{ lrn }}</span>
    </span>
  </div>
</template>

<style scoped>
.student {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.student__avatar {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: var(--accent);
  color: var(--secondary-foreground);
  font-size: 12px;
  font-weight: 500;
}
.student__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.student__name {
  overflow: hidden;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.student__lrn {
  font-size: 12px;
  color: var(--muted-foreground);
}
</style>
